import React, {memo, FC} from "react";
import moment from "moment";
import {Gender, GetBookingsByCourseIdWithCourseLessonBookingsQuery} from "../../../../generated/graphql";
import css from "./BookingDetails.less";
import SummarySection from "../../../../views/SummarySection/SummarySection";

type AttendeeSectionProps = {
    booking: GetBookingsByCourseIdWithCourseLessonBookingsQuery["bookingsByCourseIdWithCourseLessonBookings"][0];
};

const AttendeeSection: FC<AttendeeSectionProps> = ({booking}) => {
    const {attendee} = booking;

    if (!attendee) {
        return null;
    }
    const {firstname, lastname, gender, member, customerNumber, customerNumberPrefix} = attendee;
    const prefixedCustomerNumber = customerNumberPrefix ? `${customerNumberPrefix}${customerNumber}` : customerNumber;

    // console.log("==> DEBUG::: attendee", attendee);

    return (
        <SummarySection
            title="KursTeilnehmerin"
            className={css.section}
            content={
                <div className={css.bookingDetails}>
                    <div className={css.extraBig}>
                        <span className={css.primary}>{firstname}</span>
                        <span className={css.secondary}>{lastname}</span>
                        <span className={css.secondary}>{`(${prefixedCustomerNumber})`}</span>
                    </div>
                    <div className={css.standardContainer}>
                        <div className={css.label}>{"Mitglied"}</div>
                        <div className={css.entry}>{member ? "Mitglied" : "Nicht Mitglied"}</div>
                    </div>
                    <div className={css.standardContainer}>
                        <div className={css.label}>{"Geschlecht"}</div>
                        <div className={css.entry}>
                            {gender === Gender.Male ? "weiblich" : gender === Gender.Female ? "männlich" : "unbekannt"}
                        </div>
                    </div>
                    <div className={css.standardContainer}>
                        <div className={css.label}>{"Buchungsdatum"}</div>
                        <div className={css.entry}>{moment(booking.createDate).format("DD.MM.YYYY")}</div>
                    </div>
                </div>
            }
        />
    );
};

export default memo(AttendeeSection);
